export default __webpack_public_path__ + "static/media/service_bell.7439ae7e.mp3";